import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { PrintBatchData } from '@app/services/batches/print-batches';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WindowService } from '../../../../core/services/window/window.service';
import { OrderBatchService } from '../../../../services/order-batch/order-batch.service';
import { BatchActionsService } from '../../services/batch-actions.service';

@Component({
  selector: 'app-recently-printed-dialog',
  templateUrl: './recently-printed-dialog.html',
  styleUrls: ['./recently-printed-dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RecentlyPrintedDialog implements OnInit {
  @Input() printedBatches: PrintBatchData;
  readonly displayedColumns: string[] = [
    'BatchName',
    'PrintingTimes',
    'LastPrintingTime',
    // 'user',
    'Actions',
  ];
  printLabelsUrls: ReadonlyArray<string>;
  lastPrintingTimeString: string;
  filteredRows = [];
  searchInput: string = '';
  originalRows = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private windowService: WindowService,
    private orderBatch: OrderBatchService,
    public batchActionService: BatchActionsService,
  ) {}

  ngOnInit(): void {
    this.orderBatch.getBatchesHistory().then((orderBatches) => {
      this.filteredRows = orderBatches.fullHistory;
      this.originalRows = this.filteredRows;
    });
  }

  updatePrintedRows(event) {
    let searchedName;
    const updatedRows = [];
    this.originalRows.forEach((row) => {
      let pushToNewUpdatedRows = true;
      const batchName = row.name;
      if (event) {
        searchedName = event.target.value.toLowerCase();
      } else {
        batchName.toLowerCase();
      }
      if (batchName != null) {
        if (batchName.toLowerCase().includes(searchedName) || event === '') {
          if (event === '') {
            this.searchInput = '';
          }
        } else {
          pushToNewUpdatedRows = false;
        }
      }
      if (pushToNewUpdatedRows) {
        updatedRows.push(row);
      }
    });
    this.filteredRows = updatedRows;
  }
}
